import React from "react";
import { Dialog } from "primereact/dialog";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";

export type MusicAuditColumnConfig = {
  field: string;
  header: string;
  sortable?: boolean;
  visible: boolean;
};

export type MusicAuditColumnVisibilityDialogProps = {
  visible: boolean;
  columns: MusicAuditColumnConfig[];
  onHide: () => void;
  onVisibilityChange: (field: string, visible: boolean) => void;
  onReset: () => void;
};

/**
 * Shared column-visibility dialog chrome for Music Asset Audit tables.
 * Filter fields, URL sync, and DataTable stay page-owned.
 */
export function MusicAuditColumnVisibilityDialog({
  visible,
  columns,
  onHide,
  onVisibilityChange,
  onReset,
}: MusicAuditColumnVisibilityDialogProps) {
  return (
    <Dialog
      header="Column Visibility"
      visible={visible}
      style={{ width: "40vw" }}
      onHide={onHide}
    >
      <div className="grid">
        {columns.map((column) => (
          <div key={column.field} className="col-12 md:col-6 lg:col-4">
            <div className="flex align-items-center gap-2 p-2">
              <Checkbox
                checked={column.visible}
                onChange={(e) =>
                  onVisibilityChange(column.field, e.checked || false)
                }
              />
              <label className="text-sm">{column.header}</label>
            </div>
          </div>
        ))}
      </div>
      <div className="flex justify-content-end gap-2 mt-3">
        <Button
          label="Reset All"
          icon="pi pi-refresh"
          onClick={onReset}
          severity="secondary"
          outlined
        />
        <Button label="Close" icon="pi pi-times" onClick={onHide} />
      </div>
    </Dialog>
  );
}
